import { Component, inject, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Api } from '../../services/api';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { ContactService } from '../../services/contact.service';

@Component({
  selector: 'app-mdl-contact-function',
  imports: [FormsModule, CommonModule, NgSelectModule],
  templateUrl: './mdl-contact-function.html',
  styleUrl: './mdl-contact-function.css'
})
export class MdlContactFunction {
  public api = inject(Api);
  public contactService = inject(ContactService);
  public accounts: any = [];
  public selectedAccount = '';
  public contactSelected: any = [];
  public selectedFunction: string = '';

  public functions: any = [];

  public step = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public mdl: MatDialogRef<MdlContactFunction>,
    public router: Router
  ){
    this.getAccounts();
    this.getFunctions();
  }

  closeMdl(){
    this.mdl.close();
  }

  getFunctions(){
    this.functions = this.contactService.getFunctionsData();
  }

  getAccounts(){
    try {
      this.api.getContacts().subscribe({
        next:(data:any) =>{
          this.accounts = data.contactos;
          console.log(this.accounts);
        },
        error: (error:any)=>{
          console.error(error);
        }
      });
    } catch (error) {
      console.error(error);
    }
  }

  nextStep(){
    this.step = 1;
    console.log(this.selectedAccount);
    for (let i = 0; i < this.accounts.length; i++) {
      if(this.accounts[i].contacto_id === this.selectedAccount){
        this.contactSelected = this.accounts[i];
      }
    }

    console.log(this.contactSelected);
  }

  saveFunction(){
    this.api.showLoading();
    let data = {
      contacto_id: this.contactSelected.contacto_id, 
      funcion: this.selectedFunction
    };
    this.api.updateContactFunction(data).subscribe({
      next: (data:any)=>{
        setTimeout(() => {
          console.log(data);
          this.api.hideLoading();
          window.location.reload();
        }, 500);
      },
      error: (err:any)=>{
        console.error(err);
      }
    })
  }

}
